import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Este ebook sustituye al médico?',
  a: 'No, en absoluto. Espalda Libre es una guía educativa basada en experiencia personal. Es un complemento para entender tu proceso y mejorar tus hábitos, pero nunca debe sustituir el diagnóstico, tratamiento o consejo de un profesional sanitario.'
}, {
  q: '¿Es solo para personas con hernias discales?',
  a: 'No. Aunque mi experiencia personal parte de dos hernias discales, los principios, hábitos y herramientas mentales que comparto son útiles para cualquier persona que sufra de dolor lumbar, ciática o dolor de espalda inespecífico.'
}, {
  q: '¿Lo puedo leer en el móvil?',
  a: 'Sí, totalmente. El ebook se entrega en formato PDF optimizado para que puedas leerlo cómodamente desde tu teléfono móvil, tablet o computadora.'
}, {
  q: '¿Es útil si llevo meses o años con dolor?',
  a: 'Sí. El dolor crónico tiene un componente emocional y de sensibilización muy fuerte. La guía aborda no solo la parte física, sino cómo gestionar el miedo y la frustración que se acumulan con el tiempo.'
}, {
  q: '¿Es un libro técnico o fácil de entender?',
  a: 'Es extremadamente fácil de entender. Está escrito de tú a tú, sin jerga médica complicada. Mi objetivo es que sientas que estás tomando un café con alguien que te explica las cosas de forma clara y humana.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-warm-bg" data-id="element-79">
      <div className="max-w-3xl mx-auto px-6" data-id="element-80">
        <FadeIn className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-6" data-id="element-82">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-84">
              <div className="bg-white rounded-xl border border-warm-alt overflow-hidden cursor-pointer transition-shadow hover:shadow-sm" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <div className="p-6 flex justify-between items-center" data-id="element-86">
                  <h3 className="font-medium text-warm-dark pr-8" data-id="element-87">{faq.q}</h3>
                  <ChevronDown className={`w-5 h-5 text-warm-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-88" />
                </div>
                <AnimatePresence data-id="element-89">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-90">
                      <div className="p-6 pt-0 text-warm-dark/70 leading-relaxed border-t border-warm-alt/50 mt-2" data-id="element-91">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}